export default "__VITE_ASSET__8E6tRt1q__"